/**
 * Fetch the roadmap comments referenced by a RoadmapCommentInfo (deep-link from
 * notifications).
 * Mirrors Flutter RoadmapRepository.getNotificationComments
 * (lib/presentation/bottom_sheet/roadmap_comments_bottom_sheet.dart:205-267,
 * lib/data/data_sources/roadmap_data_source.dart:219-247 — id list built as
 * [id, ...parentId?, ...replyId?]).
 */

import { RoadmapCommentService } from '@/domain/services/roadmapComment/roadmapCommentService';
import type { RoadmapCommentInfoEntity } from '@/domain/entities/info/roadmapCommentInfoEntity';
import type { RoadmapCommentEntity } from '@/domain/entities/roadmapComment/roadmapCommentEntity';

export class FetchRoadmapNotificationCommentsUseCase {
  constructor(private service = RoadmapCommentService.getInstance()) {}

  async execute(
    roadmapItemId: string,
    commentInfo: RoadmapCommentInfoEntity,
  ): Promise<RoadmapCommentEntity[]> {
    const ids: string[] = [commentInfo.id];
    if (commentInfo.parentId) ids.push(commentInfo.parentId);
    if (commentInfo.replyId) ids.push(commentInfo.replyId);
    return this.service.fetchCommentsByIds(roadmapItemId, ids);
  }
}

export const fetchRoadmapNotificationCommentsUseCase =
  new FetchRoadmapNotificationCommentsUseCase();
